import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { View } from '@fullcalendar/core';
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'hub-dropdown',
  templateUrl: './hub-dropdown.component.html',
  styleUrls: ['./hub-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubDropdownComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HubDropdownComponent),
      multi: true,
    },
  ],
})
export class HubDropdownComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() labelColor?: string = null;
  @Input() dateFormat: string = 'D, dd M yy';
  @Input() placeholder: string = '';
  @Input() options: string[] = [];
  @Input() optionLabel = '';
  @Input() optionValue = '';
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() iconColor?: string = '#6B728C';
  @Input() formatList: any[] = [];
  @Output() selectionChange = new EventEmitter<any>();

  @ViewChild('dropDownRef') dropDownRef!: Dropdown;

  value: any | null = null;

  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: FormControl): ValidationErrors | null {
    return control.errors;
  }

  handleDataChange(event: any) {
    console.log('Data changed:', event);
    this.value = event.value;
    this.onChange(this.value);
    this.selectionChange.emit(this.value);
  }

  focus(): void {
    if (this.dropDownRef) {
      setTimeout(() => {
        this.dropDownRef.show();
      }, 0);
    }
  }

  show(): void {
    if (this.dropDownRef) {
      this.dropDownRef.show();
    }
  }

  hide(): void {
    if (this.dropDownRef) {
      this.dropDownRef.hide();
    }
  }

  focusInput(): void {
    if (this.dropDownRef && this.dropDownRef.focusInputViewChild) {
      setTimeout(() => {
        this.dropDownRef.focusInputViewChild.nativeElement.focus();
      }, 0);
    }
  }
}
